export const roundTo1dp = number => (
  Math.round(number * 10) / 10
);